import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { getAllParkingSlotsAsync } from './familyFestParkingSlotThunk';
const initialState = {
    status: APIStatus.IDLE,
    parkingSlots: null
};
export const familyFestParkingSlotSlice = createSlice({
    name: 'familyFestParkingSlot',
    initialState,
    reducers: {
        resetParkingSlotStatus: (state) => {
            state.status = APIStatus.IDLE;
            state.apiError = undefined;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllParkingSlotsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllParkingSlotsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.parkingSlots = action.payload;
        })
            .addCase(getAllParkingSlotsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export const { resetParkingSlotStatus } = familyFestParkingSlotSlice.actions;
export default familyFestParkingSlotSlice.reducer;
